var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getCss('base'),style:(_vm.styles.base)},[_c('canvas',{staticClass:"pag-anime-canvas",attrs:{"id":("pag-anime-" + (this.uid))}})])}
var staticRenderFns = []

export { render, staticRenderFns }